var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "damaged-parts view" }, [
    _c(
      "div",
      { staticClass: "view_top" },
      [
        !_vm.isE2EFlow
          ? _c("ma-navbar-category", {
              attrs: {
                titleNavbar: _vm.titleNavBar,
                qaName: "go-to-damagedItemsView-btn",
                handleClickBack: _vm.handleOnClickPrevRoute,
              },
            })
          : _vm._e(),
        _vm.isE2EFlow
          ? _c("ma-navbar-stepper", {
              attrs: {
                numberOfStep: 2,
                textOfStep: _vm.$t("Déclaration des dommages"),
                handleClickBack: _vm.handleOnClickPrevRoute,
                qaName: "go-to-damagedItemsView-btn",
                arrowIsAllow: true,
              },
            })
          : _vm._e(),
      ],
      1
    ),
    _c("div", { staticClass: "view_content" }, [
      _vm.flowName === "damage_billma_agent_new" ||
      (_vm.flowName === "e2e_new" && _vm.isMultidamage)
        ? _c("p", { staticClass: "mg mg--b-4" }, [
            _vm._v(_vm._s(_vm.$t("damagedParts.multidamageDescription"))),
          ])
        : _vm._e(),
      _vm.isMultidamage
        ? _c(
            "div",
            { key: _vm.multidamageListKey },
            _vm._l(_vm.multidamagePieces, function (damagedKey) {
              return _c(
                "div",
                { key: damagedKey.id, staticClass: "damage-parts_part" },
                _vm._l(damagedKey.pieces, function (damagedPiece) {
                  return _c(
                    "div",
                    {
                      key: damagedPiece.id,
                      staticClass: "damage-parts_part_piece",
                    },
                    [
                      _c("div", { staticClass: "view_content_markdown" }, [
                        _c("h1", [
                          _vm._v(
                            _vm._s(damagedKey.literal) +
                              " " +
                              _vm._s(damagedPiece.pieceId)
                          ),
                        ]),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.datadamagedParts &&
                                _vm.datadamagedParts[0] &&
                                typeof _vm.datadamagedParts[0]
                                  .self_care_literal !== "undefined"
                                ? _vm.datadamagedParts[0].self_care_literal
                                : ""
                            )
                          ),
                        ]),
                        _vm.partsLoaded
                          ? _c(
                              "ul",
                              {
                                staticClass: "view-list has-two-cols",
                                attrs: { "qa-list-damaged-Parts": "" },
                              },
                              _vm._l(damagedPiece.form, function (damagedPart) {
                                return _c(
                                  "li",
                                  [
                                    _c("ma-damaged-item-btn", {
                                      attrs: {
                                        buttonTitle: damagedPart.literal,
                                        valueInput: damagedPart.key,
                                        type: _vm.typeButton,
                                        buttonClass: _vm.getBtnClass,
                                        imgName: damagedPart.image,
                                        inputChecked: _vm.checkPartSelected(
                                          damagedPiece,
                                          damagedPart.key
                                        ),
                                      },
                                      on: {
                                        "button:clicked": function ($event) {
                                          return _vm.handleOnClickMultidamagePart(
                                            damagedPiece,
                                            damagedPart.key,
                                            damagedPart.literal
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              )
            }),
            0
          )
        : _vm._e(),
      !_vm.isMultidamage
        ? _c("div", { staticClass: "view_content_markdown" }, [
            _c("h1", [_vm._v(_vm._s(_vm.getDamagedItemLiteral))]),
            _c("p", [_vm._v(_vm._s(_vm.damagedItemDescriptionLiteral) + " ")]),
            _c(
              "ul",
              {
                staticClass: "view-list has-two-cols",
                attrs: { "qa-list-damaged-Parts": "" },
              },
              _vm._l(_vm.datadamagedParts.options, function (damagedPart) {
                return _c(
                  "li",
                  [
                    _c("ma-damaged-item-btn", {
                      attrs: {
                        buttonTitle: damagedPart.literal,
                        valueInput: damagedPart.key,
                        type: _vm.typeButton,
                        buttonClass: _vm.getBtnClass,
                        imgName: damagedPart.image,
                      },
                      on: { "button:clicked": _vm.handleClickdamagedPart },
                    }),
                  ],
                  1
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "view_actions" },
      [
        _vm.typeButton === "input-multiSelect-txt"
          ? _c("ma-add-damaged-parts-btn", {
              attrs: {
                "qa-addDamaged-parts-btn": "",
                title: _vm.$t("damagedParts.buttonTitle"),
                shouldBeDisabled:
                  _vm.btnAddDamagedPartsIsDisabled ||
                  _vm.stateWarrantyReport.length === 0,
                handleButtonClick: _vm.handleAddDamages,
                btnType: "functionalBtn",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }